var _circle, _rect, _rect2, _path, _rect3, _circle2, _circle3, _circle4, _circle5, _circle6, _circle7, _path2, _circle8, _circle9, _path3, _circle0, _circle1, _circle10, _rect4, _line, _line2, _line3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFullLoadTms(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 400,
    height: 400,
    viewBox: "0 0 400 400",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 200,
    cy: 200,
    r: 180,
    fill: "#F0F4F8",
    opacity: 0.5
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 120,
    y: 180,
    width: 140,
    height: 80,
    rx: 8,
    fill: "#2563EB"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 260,
    y: 180,
    width: 60,
    height: 80,
    rx: 8,
    fill: "#3B82F6"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M 120 180 L 120 160 L 160 140 L 180 140 L 180 180 Z",
    fill: "#1E40AF"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 130,
    y: 150,
    width: 30,
    height: 20,
    rx: 2,
    fill: "#DBEAFE"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 150,
    cy: 270,
    r: 20,
    fill: "#1F2937"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 150,
    cy: 270,
    r: 12,
    fill: "#6B7280"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 240,
    cy: 270,
    r: 20,
    fill: "#1F2937"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 240,
    cy: 270,
    r: 12,
    fill: "#6B7280"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 290,
    cy: 270,
    r: 20,
    fill: "#1F2937"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 290,
    cy: 270,
    r: 12,
    fill: "#6B7280"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M 300 100 L 300 140 L 285 125 Z",
    fill: "#EF4444"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 300,
    cy: 100,
    r: 15,
    fill: "#DC2626"
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 300,
    cy: 100,
    r: 8,
    fill: "#FEE2E2"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M 80 120 Q 150 80, 220 110 T 320 100",
    stroke: "#10B981",
    strokeWidth: 3,
    strokeDasharray: "8 4",
    fill: "none"
  })), _circle0 || (_circle0 = /*#__PURE__*/React.createElement("circle", {
    cx: 80,
    cy: 120,
    r: 6,
    fill: "#10B981"
  })), _circle1 || (_circle1 = /*#__PURE__*/React.createElement("circle", {
    cx: 150,
    cy: 90,
    r: 6,
    fill: "#10B981"
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    cx: 220,
    cy: 110,
    r: 6,
    fill: "#10B981"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 90,
    y: 220,
    width: 40,
    height: 50,
    rx: 4,
    fill: "#FFFFFF",
    opacity: 0.9
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 100,
    y1: 235,
    x2: 120,
    y2: 235,
    stroke: "#2563EB",
    strokeWidth: 2
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 100,
    y1: 245,
    x2: 120,
    y2: 245,
    stroke: "#2563EB",
    strokeWidth: 2
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 100,
    y1: 255,
    x2: 115,
    y2: 255,
    stroke: "#2563EB",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFullLoadTms);
export default __webpack_public_path__ + "static/media/full-load-tms.179c654180c50cd2f27b040ebd44bd6c.svg";
export { ForwardRef as ReactComponent };